import React, { useEffect, Fragment, useRef } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import {
  GetBillingChargesGroupById,
  UpdateBillingChargesGroup
} from "../../../api/masters/billingChargesGroupAPI";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  creditAcc: yup.string().required("Credit Acc is required"),
  printSrNo: yup.string().required("Print Sr No is required"),
  fuel: yup.string().required("Fuel is required"),
  code: yup.string().optional(),
  hsnCode: yup.string().optional()
});

const EditBillingChargesGroup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchData = async () => {
    try {
      const response = await GetBillingChargesGroupById(id); // Make sure login function returns token

      if (response.success) {
        setValue("name", response.data.name); // Set default values
        setValue("creditAcc", response.data.creditAcc);
        setValue("printSrNo", response.data.printSrNo);
        setValue("fuel", response.data.fuel);
        setValue("code", response.data.code);
        setValue("hsnCode", response.data.hsnCode);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(
    () => {
      const loadData = async () => {
        try {
          dispatch({ type: "LOADER_START" });
          await fetchData();
        } catch (error) {
          showToast("error", error);
        } finally {
          dispatch({ type: "LOADER_STOP" });
        }
      };

      loadData();
    },
    [id]
  );

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await UpdateBillingChargesGroup(id, data);
      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return <Fragment>
      <Breadcrumb parent="Billing Charges Group" title="Edit Billing Charges Group" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <h5>Edit Billing Charges Group</h5>
                  <Link to={`/masters/billing-charges-group/list`}>
                    <button className="btn btn-primary" id="list">
                      List Billing Charges Group
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Billing Charges Group
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form ref={formRef} className="form theme-form" onSubmit={handleSubmit(onSubmit)}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Name *</label>
                        <input className="form-control" id="name" type="text" placeholder="Billing Charges Group Name" {...register("name")} />
                        {errors.name && <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="creditAcc">Credit Account *</label>
                        <input className="form-control" id="creditAcc" type="text" placeholder="Credit Account" {...register("creditAcc")} />
                        {errors.creditAcc && <p className="text-danger">
                            {errors.creditAcc.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="printSrNo">Print Sr No *</label>
                        <input className="form-control" id="printSrNo" type="number" placeholder="Print Sr No" {...register("printSrNo")} />
                        {errors.printSrNo && <p className="text-danger">
                            {errors.printSrNo.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="fuel">Fuel</label>
                        <select className="form-control" {...register("fuel")}>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        {errors.fuel && <p className="text-danger">
                            {errors.fuel.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="code">Code</label>
                        <input className="form-control" id="code" type="text" placeholder="Code" {...register("code")} />
                        {errors.code && <p className="text-danger">
                            {errors.code.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="hsnCode">HSN Code</label>
                        <input className="form-control" id="hsnCode" type="text" placeholder="HSN Code" {...register("hsnCode")} />
                        {errors.hsnCode && <p className="text-danger">
                            {errors.hsnCode.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>;
};

export default EditBillingChargesGroup;
